import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IReqAutoFillInfo, IResAutoFillInfo } from './credit-card.interface';

@Injectable({
  providedIn: 'root',
})
export class CreditCardService {
  constructor(protected http: HttpClient) {}

  getAutoFillInfo(request: IReqAutoFillInfo): Observable<IResAutoFillInfo> {
    const url = '/api/v2/checkout/getAutoFillInfo';
    return this.http.post<IResAutoFillInfo>(url, request).pipe(
      map((response) => {
        if (!response['message']) {
          return response;
        }
      })
    );
  }
}
